import React from "react";
import Paper from "material-ui/Paper";
import Grid from "material-ui/Grid";
import Typography from "material-ui/Typography";
import { ListItemText } from "material-ui/List";
import Select from "material-ui/Select";
import Checkbox from "material-ui/Checkbox";
import Input, { InputLabel } from "material-ui/Input";
import { MenuItem } from "material-ui/Menu";
import Switch from "material-ui/Switch";
import { FormGroup, FormControlLabel, FormLabel } from "material-ui/Form";
import {
  Brush,
  LineChart,
  ReferenceLine,
  Line,
  Area,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  Text,
  Label
} from "recharts";
import Button from "material-ui/Button";
import Icon from "material-ui/Icon";

import CustomLegend from "../../../components/legend";
import { withStyles } from "material-ui/styles";
import styles from "./styles";

class LineChartViewer extends React.Component {
  constructor(props) {
    super(props);
  }

  setFullView = e => {
    const { graphType, renderFullView } = this.props;
    renderFullView(graphType);
  };

  render() {
    const {
      classes,
      translate,
      pairs,
      data,
      type,
      height,
      selectedPairs,
      combinedSelectedPairs,
      chartLineStyle,
      chartMeasurement,
      chartMeasurementUnit,
      showMargin,
      fullView,
      combined,
      subtest,
      CustomTooltip,
      isLt4 = false
    } = this.props;
    let _data = JSON.parse(JSON.stringify([...data]));
    _data.map(d => {
      if (chartMeasurementUnit === "feet") {
        d.name = Number(Number(d.name * 3.28084).toFixed(2));
        d.nameRounded = chartMeasurement === "log" ? d.name + 1 : d.name;
      } else {
        d.name = Number(Number(d.name).toFixed(2));
        d.nameRounded = chartMeasurement === "log" ? d.name + 1 : d.name;
      }
    });
    return (
      <div ref="line-chart-container" align="center">
        <Grid container spacing={24}>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <Typography className={classes.wow} type={"title"}>
              {type}
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            lg={12}
            md={12}
            xl={12}
            align="right"
          >
            <Button mini onClick={this.setFullView}>
              <Icon>{fullView ? "fullscreen_exit" : "fullscreen"}</Icon>
            </Button>
          </Grid>
        </Grid>

        <ResponsiveContainer width="100%" height={height}>
          <LineChart data={_data} label="data">
            <XAxis
              dataKey="nameRounded"
              minTickGap={30}
              padding={{ left: 20, right: 20 }}
              scale={chartMeasurement}
              height={40}
              interval="preserveStartEnd"
              tickFormatter={tick => {
                if (chartMeasurement === "log") {
                  return Number(tick - 1).toFixed(2);
                } else {
                  return Number(tick).toFixed(2);
                }
              }}
              tick={{ fontSize: "12px" }}
            >
              <Label
                value={`${translate("Distance")} (${translate(
                  chartMeasurementUnit
                )})`}
                offset={-10}
                position="bottom"
                fontSize="14px"
              />
            </XAxis>
            {isLt4 ? (
              <YAxis
                type="number"
                domain={["auto", "auto"]}
                interval="preserveStartEnd"
                label={{
                  value: `${translate(subtest)}  (${translate("dB")})`,
                  offset: 10,
                  angle: -90,
                  dy: -5,
                  position: "insideBottomLeft",
                  fontSize: "14px"
                }}
                tick={{ fontSize: "12px" }}
              />
            ) : (
              <YAxis hide={true} />
            )}
            <CartesianGrid strokeDasharray="3 3" />
            <Tooltip
              content={CustomTooltip}
              pairs={pairs}
              selectedPairs={selectedPairs}
              showMarginValue={showMargin}
              combinedSelectedPairs={combinedSelectedPairs}
              combined={combined}
              chartMeasurementUnit={chartMeasurementUnit}
              translate={translate}
            />
            <Legend
              content={<CustomLegend translate={translate} />}
              selectedPairs={selectedPairs}
              pairs={pairs}
              align="center"
              verticalAlign="top"
            />
            <Text scaleToFit={true} />
            {selectedPairs &&
              selectedPairs.map((pair, key) => {
                return (
                  <Line
                    key={key}
                    hide={!pair.checked}
                    type="monotone"
                    dataKey={pair.key}
                    stroke={pair.stroke}
                    dot={false}
                  />
                );
              })}
            (combined) &&
            {combinedSelectedPairs &&
              combinedSelectedPairs.map((pair, key) => {
                return (
                  <Line
                    key={key + pair.tempKey}
                    hide={!pair.checked}
                    type="monotone"
                    dataKey={key + pair.tempKey}
                    stroke={pair.stroke}
                    dot={false}
                  />
                );
              })}
            <Brush
              dataKey="nameRounded"
              height={25}
              stroke="#8884d8"
              y={height - 25}
              tickFormatter={tick => {
                if (chartMeasurement === "log") {
                  return Number(tick - 1).toFixed(2);
                } else {
                  return Number(tick).toFixed(2);
                }
              }}
            />
          </LineChart>
        </ResponsiveContainer>
      </div>
    );
  }
}

export default withStyles(styles)(LineChartViewer);
